import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";
import { createInventoryHealthForHubsMatrix } from "../../utils/inventory_health_for_hubs_matrix";
import { useInventoryHealthCellExplanation } from "../inventory_health/use_inventory_health_cell_explanation";

export const InventoryHealthForHubsContainer = () => {
  const { cellExplanation, cellExplanationEnabled, onRenderedSourceChange } =
    useInventoryHealthCellExplanation("for_hubs");
  // Customer-specific date hierarchy configurations
  const dateHierarchyColumnFilter = {
    week: "week",
    month: "month",
    day: "day",
  };

  // Hardcoded measure options for the dropdown
  const measureColumnFilter = (params: DatePivotParams) => {
    const dateHierarchy =
      params.dateHierarchy.charAt(0).toUpperCase() +
      params.dateHierarchy.slice(1) +
      "s";
    return {
      "Purchase Order To Place": "Purchase Order To Place",
      "Starting Inventory On Hand": "Starting Inventory On Hand",
      "Forecasted Sales": "Forecasted Sales",
      "purchase order arrivals": "PO Arrivals",
      // ENG-288: "to make" = full obligation (drives the PO); "departures" =
      // what the hub can actually ship after the on-hand cap.
      "transfer order needed": "Transfer Order Needed",
      "transfer order to place": "Transfer Order To Place",
      "Ending Inventory On Hand": "Ending Inventory On Hand",
      "Unfulfilled Demand": "Unfulfilled Demand",
      [`Target ${dateHierarchy} of Supply`]: `Target ${dateHierarchy} of Supply`,
      [`Starting ${dateHierarchy} of Supply`]: `Starting ${dateHierarchy} of Supply`,
      [`Ending ${dateHierarchy} of Supply`]: `Ending ${dateHierarchy} of Supply`,
      "In Stock Rate": "In Stock Rate",
    };
  };

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "supply_walk_parallelized_for_hubs",
        folder: "outputs",
        title: "Inventory Health: Hubs",
        viewContextSurfaceId: "inventory-health",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: [],
        measureColumnFilter,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.EnableChartView,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createInventoryHealthForHubsMatrix,
        chunkedMatrixTransformId: "supply_walk_parallelized_matrix_for_hubs",
        enablePoCellPopover: true,
        enableForecastedSalesPopover: true,
        excludeDetailRows: true,
        cellExplanation,
        cellExplanationEnabled,
        onRenderedSourceChange,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
